(function(document, window, undefined) {
	window.IPRedirect = {
		init: function(settings) {

			// Assignment
			var self = this;

			self.settings = settings;

			//get theme settings value of URL param name to disable redirect
			self.disableRedirectURLparam = settings["disable_redirect_URL_param"];
			if ((self.disableRedirectURLparam != "") && (self.getQueryVariable(self.disableRedirectURLparam) == "off")){
				return false;
			}

			self.redirect = localStorage.getItem("location-redirect");
			self.catchAllCountries = settings["redirect_catch_all_countries"];
			self.catchAllURL = settings["redirect_catch_all_url"];
			self.catchAllName = settings["redirect_catch_all_name"];

			self.catchAllCountries2 = settings["redirect_catch_all_countries2"];
			self.catchAllURL2 = settings["redirect_catch_all_url2"];
			self.catchAllName2 = settings["redirect_catch_all_name2"];

			self.ipWhiteList = settings["ip_white_list"];

			self.forceRedirect = settings["redirect_force"] ? true : false;
			self.relativeRedirect = settings["redirect_relative"] ? true : false;
			self.countryTranslations = {
				"Sweden": "Sverige"
			};
			
			self.domain = "https://reallyfreegeoip.org/json/?callback=";
			self.redirects = [];
			self.urlMap = {};

			self.location = {};

			// Preparation
			self.loadRedirects(settings);
			self.mapURLs(self.redirects, "::");
			self.redirect = (typeof self.redirect == "string") ? JSON.parse(self.redirect) : {shown: false, date: null};
			self.redirect.shown = self.getIsRedirectShown();

			// Initialization successful
			return true;
		},
		getQueryVariable: function(variable) {
			var self = this;

			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return(false);
		},
		run: function() {
			var self = this;
			var successCallback = self.fetchAndRedirectOnResponse,
				activateRedirect = true;

			if ( activateRedirect ) {
				self.makeServerCall( self.fetchLocationInfoAndRunCallback, successCallback );
			}
		},
		loadRedirects: function(settings) {
			var self = this;
			for (var i = 1; i < 11; ++i) {
				var name = "redirect_" + i;
				self.redirects.push( settings[name] );
			}
		},
		mapURLs: function(stringList, splitter) {
			var self = this;

			for (var i = 0; i < stringList.length; ++i) {
				if ( stringList[i] && stringList[i] != "") {
					var splitString = stringList[i].split(splitter);
					if (splitString[2].indexOf("http://") === -1 && splitString[1].indexOf("https://") === -1 ) {
						splitString[2] = "http://" + splitString[2];
					}

					self.urlMap[splitString[0]] = {
						"name": splitString[1],
						"url": splitString[2]
					};
				}
			}

			if (self.catchAllCountries.length > 0) {
				var countries = self.catchAllCountries.split(/[\s,]+/);
				for (var i = 0; i < countries.length; ++i) {
					self.urlMap[ countries[i] ] = {
						"name": self.catchAllName,
						"url": self.catchAllURL
					}
				}
			}

			if (self.catchAllCountries2.length > 0) {
				var countries2 = self.catchAllCountries2.split(/[\s,]+/);
				for (var j = 0; j < countries2.length; ++j) {
					self.urlMap[ countries2[j] ] = {
						"name": self.catchAllName2,
						"url": self.catchAllURL2
					}
				}
			}

			return self.urlMap;
		},
		getIsRedirectShown: function() {
			var self = this,
				today = new Date(),
				prevDate = new Date(self.redirect.date),
				dayLength = 1000 * 24 * 60 * 60, // in milliseconds
				diffDate = today - prevDate;

			// display query again if localStorage is older than 30 days
			if ( diffDate / dayLength > 30 ) {
				return false;
			}
			return true;
		},
		makeServerCall: function( serverCall, callback ) {
			return serverCall(callback);
		},
		fetchLocationInfoAndRunCallback: function( successCallback ) {
			var self = IPRedirect;
			fetch(self.domain, {
				method: "GET"
			}).then(function (response) {
				response.json().then(function (content) {
					successCallback(content)
				});
			}).catch((err) => console.log(err));
		},
		
		fetchAndRedirectOnResponse: function( location ) {
			var self = IPRedirect;
			var ipWhiteList = self.ipWhiteList;

			var botPattern = "(googlebot\/|Googlebot-Mobile|Chrome-Lighthouse|Googlebot-Image|Google favicon|Mediapartners-Google|AdsBot-Google-Mobile|AdsBot-Google|AdsBot-Google-Mobile-Apps|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
			var re = new RegExp(botPattern, 'i');
			var userAgent = navigator.userAgent;

			self.location = location;

			if (!re.test(userAgent)) {
				if (ipWhiteList.indexOf(location.ip) == -1) {
					if (self.urlMap[location.country_code] != null) {
						if (self.urlMap[location.country_code].url != null) {
							if (self.relativeRedirect) {
								window.top.location.assign(self.urlMap[location.country_code].url + window.location.pathname + window.location.search);
							} else {
								window.top.location.assign(self.urlMap[location.country_code].url);
							}
						}
					}
				};
			};
		},
		saveRedirect: function(key, val) {
			var redirect = {
				shown: true,
				date: Date()
			};
			localStorage.setItem("location-redirect", (JSON.stringify(redirect)));
		}
	};
})(document, window);